import { render, staticRenderFns } from "./TaskLogsListCard.vue?vue&type=template&id=39c86dd1&"
import script from "./TaskLogsListCard.vue?vue&type=script&lang=js&"
export * from "./TaskLogsListCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports